import { useSyncExternalStore } from 'react';

import { session, type SessionStatus } from './api';

export function useSessionStatus(): SessionStatus {
  return useSyncExternalStore(session.subscribe, session.status);
}
